<script lang="ts">
import { useCtaComponent } from '@monogrid/vue-boost'
import { useThrottleFn } from '@vueuse/core'
import { computed, defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'CtaComponent',
  props: {
    isPrimary: {
      type: Boolean,
      default: false
    }
  },
  emits: [],
  setup (props, context) {
    const { component, bindings } = useCtaComponent(context)
    const isClicked = ref(false)

    const styleMode = computed(() => {
      return props.isPrimary ? 'primary primary-cta px-6 sm:px-8 py-2 sm:py-4 text-white uppercase border-2 rounded-full' : 'px-8 py-4 border-2 border-black text-black uppercase'
    })

    const handleClick = () => {
      isClicked.value = !isClicked.value

      setTimeout(() => {
        isClicked.value = false
      }, 200)
    }

    const throttleClick = useThrottleFn(handleClick, 1000)

    return {
      bindings,
      component,
      isClicked,
      throttleClick,
      styleMode
    }
  }
})
</script>

<template>
  <component
    :is="component"
    :class="[styleMode]"
    class="px-4 hover:cursor-pointer"
    v-bind="bindings"
    @click.prevent="throttleClick"
  >
    <slot />
  </component>
</template>

<style lang="scss" scoped>
.primary {
  border-color: #ffffff9a;
  backdrop-filter: $backdrop;
  background-color: $c-light;
  box-shadow: inset 0 5px 4px #ffffff3b, inset 0 0 6px #ffffff7c;
  transition: transform 0.3s ease-out;
  will-change: transform;
}

.scaled-down {
  transform: scale(0.8);
}
</style>
